import { Skeleton } from '@/components/ui/skeleton'

export function PageSkeleton({ sections = 2 }: { sections?: number }) {
  return (
    <div className="space-y-6 animate-in fade-in duration-300">
      {/* PageHeader skeleton */}
      <div className="space-y-2">
        <Skeleton className="h-6 w-48" />
        <Skeleton className="h-4 w-80" />
      </div>

      {/* SectionCard skeletons */}
      {Array.from({ length: sections }).map((_, i) => (
        <div key={i} className="rounded-[10px] border border-border p-5 space-y-4">
          <div className="space-y-1.5">
            <Skeleton className="h-5 w-36" />
            <Skeleton className="h-4 w-64" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-8 w-full" />
            </div>
            <div className="space-y-2">
              <Skeleton className="h-4 w-28" />
              <Skeleton className="h-8 w-full" />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
